import React, { useEffect } from 'react'
import { Configs_props } from '../elements/savedConfigs/interface'
import { FlexDiv } from '../../../../elements/NumberInput/NumberInputStyles'
import SavedConfig from '../elements/savedConfigs/SavedConfig'

export default function Configs({
  configOne,
  configTwo,
  configThree,
  handleConfig,
  active,
}: Configs_props) {
  return (
    <>
      <FlexDiv>
        <SavedConfig
          title='CONFIG 1'
          emptyConfig={configOne.isSaved === '0'}
          rollUnder={configOne.isSaved === '1' && configOne.rollUnder == '1'}
          number={configOne.isSaved === '1' && configOne.rollNumber}
          id={1}
          handleConfig={handleConfig}
          isActive={active === 1}
        />
        <SavedConfig
          title='CONFIG 2'
          emptyConfig={configTwo.isSaved === '0'}
          rollUnder={configTwo.isSaved === '1' && configTwo.rollUnder == '1'}
          number={configTwo.isSaved === '1' && configTwo.rollNumber}
          id={2}
          handleConfig={handleConfig}
          isActive={active === 2}
        />
        <SavedConfig
          title='CONFIG 3'
          emptyConfig={configThree.isSaved === '0'}
          rollUnder={
            configThree.isSaved === '1' && configThree.rollUnder == '1'
          }
          number={configThree.isSaved === '1' && configThree.rollNumber}
          id={3}
          handleConfig={handleConfig}
          isActive={active === 3}
        />
      </FlexDiv>
    </>
  )
}
